module.exports = __webpack_public_path__ + "img/right_gray.93791529.svg";